'use client';
import React from 'react';

const resources = [
  {
    type: 'article',
    tag: 'Article',
    title: '1 minute: the exploit window we could see in 2027',
    description:
      'The time between discovering a vulnerability and exploiting it has already dropped to one day. The projection is that by 2027 it will be one minute, and that changes what it means to be secure.',
    link: undefined, // no destination exists yet; React omits href when undefined
    linkText: 'Read Article',
    large: true,
  },
  {
    type: 'ebook',
    tag: 'Ebook',
    title: 'Anatomy of a DevSecOps Assessment',
    description:
      'See how we turn security findings into clear, actionable insights. This sample report walks you through a complete security assessment, from the executive summary to the technical details of each vulnerability.',
    link: undefined, // no destination exists yet; React omits href when undefined
    linkText: 'Download ebook',
    image: 'https://cdn.prod.website-files.com/68a77090b95f85ab69076143/6967cf7178d3d176c12aaf9d_BG%20card.avif',
    imageAlt: 'DevSecOps assessment report cover',
  },
  {
    type: 'case-study',
    tag: 'Case Study',
    title: 'How a global bank reduced security assessment time from a week to a day and a half.',
    description:
      'A major financial institution needed a faster way to run security assessments across teams of varying seniority and a growing attack surface. Find out how SecureOps helped make their security validation more agile.',
    link: undefined, // no destination exists yet; React omits href when undefined
    linkText: 'Read Full Case',
    image: 'https://cdn.prod.website-files.com/68a77090b95f85ab69076143/6967cf7178d3d176c12aaf9d_BG%20card.avif',
    imageAlt: 'Bank security case study',
  },
  {
    type: 'event',
    tag: 'Event',
    title: 'DevSecOps Summit 2026',
    description:
      'The most important DevSecOps event of the year. It will bring together leading industry brands, experts, and strategic partners to present new solutions, share experiences, and address the main challenges in security engineering.',
    link: undefined, // no destination exists yet; React omits href when undefined
    linkText: 'Learn more',
  },
];

export default function ResourcesSection() {
  return (
    <section className="bg-[#050a0f] border-t border-[#222] py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="mb-16">
          <p className="font-mono-brand text-[0.7rem] text-[#80edfa] uppercase tracking-widest mb-4">
            Resource Hub
          </p>
          <h2 className="font-heading text-[clamp(2rem,4vw,3rem)] text-[#f5f5f8] font-medium max-w-2xl">
            In-depth knowledge of what&apos;s happening in the cybersecurity industry
          </h2>
        </div>

        {/* Resources Grid */}
        <div className="flex flex-col lg:flex-row gap-0 border-t border-[#222]">
          {/* Large featured article */}
          <div className="lg:w-1/3 border-b lg:border-b-0 lg:border-r border-[#222]">
            <a href={resources?.[0]?.link} className="block p-8 h-full group hover:bg-[#181b1f] transition-colors duration-200">
              <p className="font-mono-brand text-[0.65rem] text-[#80edfa] uppercase tracking-widest mb-6">
                {resources?.[0]?.tag}
              </p>
              <h3 className="font-heading text-xl text-[#f5f5f8] font-medium mb-4 group-hover:text-[#80edfa] transition-colors duration-200">
                {resources?.[0]?.title}
              </h3>
              <p className="text-sm text-[#666] leading-relaxed mb-8">
                {resources?.[0]?.description}
              </p>
              <div className="flex items-center gap-2 text-[#aaa] group-hover:text-[#80edfa] transition-colors duration-200">
                <span className="font-mono-brand text-[0.65rem] uppercase tracking-widest">
                  {resources?.[0]?.linkText}
                </span>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6H10M7 3L10 6L7 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </a>
          </div>

          {/* Right column: 3 smaller cards */}
          <div className="lg:w-2/3 flex flex-col">
            {resources?.slice(1)?.map((resource, i) => (
              <a
                key={i}
                href={resource?.link}
                className={`flex gap-6 p-8 group hover:bg-[#181b1f] transition-colors duration-200 ${
                  i < resources?.length - 2 ? 'border-b border-[#222]' : ''
                }`}
              >
                {resource?.image && (
                  <div className="flex-shrink-0 w-24 h-20 overflow-hidden border border-[#222]">
                    <img
                      src={resource?.image}
                      alt={resource?.imageAlt || ''}
                      className="w-full h-full object-cover opacity-60"
                    />
                  </div>
                )}
                <div className="flex-1 flex flex-col gap-2">
                  <p className="font-mono-brand text-[0.65rem] text-[#80edfa] uppercase tracking-widest">
                    {resource?.tag}
                  </p>
                  <h3 className="font-heading text-base text-[#f5f5f8] font-medium group-hover:text-[#80edfa] transition-colors duration-200">
                    {resource?.title}
                  </h3>
                  <p className="text-xs text-[#666] leading-relaxed line-clamp-2">
                    {resource?.description}
                  </p>
                  <div className="flex items-center gap-2 text-[#aaa] group-hover:text-[#80edfa] transition-colors duration-200 mt-auto">
                    <span className="font-mono-brand text-[0.6rem] uppercase tracking-widest">
                      {resource?.linkText}
                    </span>
                    <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6H10M7 3L10 6L7 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
